module.exports = __webpack_public_path__ + "static/media/et_2.a0091895.png";